module.exports = __webpack_public_path__ + "img/bell.e876d939.png";